import type { GuildMemberCountRange } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface GuildMemberCountRangeFilterProps {
  value: GuildMemberCountRange;
  onChange: (value: GuildMemberCountRange) => void;
}

export function GuildMemberCountRangeFilter({ value, onChange }: GuildMemberCountRangeFilterProps) {
  return (
    <div className="flex gap-3">
      <div>
        <Label className="mb-1 block text-xs">Min Count</Label>
        <Input
          type="number"
          value={value.min_count ?? ""}
          onChange={(e) =>
            onChange({
              ...value,
              min_count: e.target.value ? parseInt(e.target.value) : undefined,
            })
          }
          placeholder="min"
          className="w-24"
        />
      </div>
      <div>
        <Label className="mb-1 block text-xs">Max Count</Label>
        <Input
          type="number"
          value={value.max_count ?? ""}
          onChange={(e) =>
            onChange({
              ...value,
              max_count: e.target.value ? parseInt(e.target.value) : undefined,
            })
          }
          placeholder="max"
          className="w-24"
        />
      </div>
    </div>
  );
}
